import React, {useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import {useDrag, useDrop} from 'react-dnd';
import {getEmptyImage} from 'react-dnd-html5-backend';
import {getText} from 'helpers/language-helper';
import Audio from 'components/ui/audio/audio';
import './order-dnd-item.scss';

const OrderDndItem = (props) => {
	const {
		isDroppable,
		isDraggable, 
		languageId,
		layout,
		location, 
		positionNumber, 
		itemData, 
		classes, 
		audioFileName,
		handleMoveItem
	} = props;

	/* Drag functionality */
	const [{ isDragging }, drag, preview] = useDrag({
		type: 'item',
		item: {type: 'item', id: (itemData ? itemData.id : null), location, positionNumber},
		canDrag() {return (isDraggable);},
		isDragging(monitor) {return (itemData && itemData.id === monitor.getItem().id);},
		collect: (monitor) => {return {isDragging: monitor.isDragging()};},
	});

	/* Drop functionality */
	const [{isOver, canDrop}, drop] = useDrop({
		accept: 'item',
		drop(item) {
			if (!isDroppable) return;

			if (handleMoveItem) {				
			/* Ignore hovering over itself */
				if (
					item.location === location &&  
				item.positionNumber === positionNumber
				) return;

				/* Move card */
				handleMoveItem(item.id, location, positionNumber);
			}
		},
		collect: (monitor) => {
			return {
				isOver: monitor.isOver(),
				canDrop: isDroppable
			};
		}
	});

	/* Hide browser-drawn drag preview image when dragging */
	useEffect(() => {
		preview(getEmptyImage(), { captureDraggingState: true });
	});

	/* Opacity (invisible if dragging) */
	const opacity = (isDragging ? 0 : 1);

	/* Class name */
	let className = 'OrderDndItem' + (layout ? ' ' + layout : '');
	if (classes && classes.length > 0) {classes.forEach((c) => {className += ' ' + c;});}
	if (!isDraggable) className += ' disabled';	
	if  (isOver && canDrop) className += ' hover';



	const ref = useRef(null);
	const dragDropRef = drag(drop(ref));
	
	return (
		<div
			ref={dragDropRef}
			className={className}
			style={{opacity}}
		>
			{(itemData && itemData.text) && 
				<span>{getText(itemData.text, languageId)}</span>
			}
			<div className="OrderDndItem-audio">
				<Audio 
					type='task-option'
					color='blue'
					fileName={audioFileName}
				/>
			</div>
		</div>
	);
};

OrderDndItem.propTypes = {
	isDroppable: PropTypes.bool.isRequired,
	isDraggable: PropTypes.bool.isRequired,
	audioFileName: PropTypes.string.isRequired,
	languageId: PropTypes.string.isRequired,
	layout: PropTypes.string,
	location: PropTypes.string.isRequired,
	positionNumber: PropTypes.number.isRequired,
	itemData: PropTypes.object,
	classes: PropTypes.array,
	
	handleMoveItem: PropTypes.func.isRequired
};

export default OrderDndItem;
